var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vcita-divider",style:(`--text-divider-color: ${_vm.color}`)},[(_vm.text)?_c('div',{staticClass:"text-divider",attrs:{"data-testid":"vcita-text-divider"}},[_vm._v(" "+_vm._s(_vm.text)+" ")]):_c('v-divider',{staticClass:"no-text-divider",attrs:{"data-testid":"vcita-divider","color":_vm.color}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }